import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-wrapper-primeng-form-field',
    template: `
        <div class="field grid">
<!--            <label class="col-12 mb-2 md:col-2 md:mb-0"  *ngIf="to.label && to.hideLabel !== true" [for]="id">-->
<!--                {{ to.label }}-->
<!--                <span *ngIf="to.required && to.hideRequiredMarker !== true" aria-hidden="true">*</span>-->
<!--            </label>-->
            <div class="col-12 md:col-10">
                <ng-container #fieldComponent></ng-container>
            </div>
            <small *ngIf="showError" class="p-error">
                <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
            </small>
        </div>
    `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyWrapperNon extends FieldWrapper {
}
